<template>
    <div
        class="dropdown"
        v-if="true == editable"
    >
        <div class="d-flex align-items-center">
            <template v-if="value">
                <template v-for="(item, index) in items">
                    <template v-if="index <= meta.length">
                        <template v-if="index == meta.length"
                            ><div
                                class="document is-badge view-more"
                                :key="item.id"
                                @click="showDropdown = !showDropdown"
                            >
                                +{{ items.length - meta.length }}

                                <div
                                    v-if="showDropdown && value.length > meta.length"
                                    aria-labelledby="dropdownAddItem"
                                    class="dropdown-menu dropdown-menu-right"
                                    style="display: block"
                                    v-click-outside="hidePopup"
                                >
                                    <template v-for="(item, index) in items">
                                        <template v-if="index >= meta.length">
                                            <div
                                                class="document is-badge"
                                                :key="item.id"
                                            >
                                                <div
                                                    v-if="badgeKeyIsDefined(item)"
                                                    class="badge arclight"
                                                >
                                                    {{ item[meta.badgeKey] }}
                                                </div>
                                                <span>
                                                    {{ item[meta.displayKey] }}
                                                </span>
                                                <i
                                                    class="icon-close"
                                                    @click="removeItem(index)"
                                                ></i></div
                                        ></template>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="index < meta.length">
                            <div
                                class="document is-badge"
                                :key="item.id"
                            >
                                <div
                                    v-if="badgeKeyIsDefined(item)"
                                    class="badge arclight"
                                >
                                    {{ item[meta.badgeKey] }}
                                </div>
                                <span>
                                    {{ item[meta.displayKey] }}
                                </span>
                                <i
                                    class="icon-close"
                                    @click="removeItem(index)"
                                ></i></div></template
                    ></template>
                </template>
            </template>

            <a
                href="#"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn btn-add"
                @click="showModal = !showModal"
                ><i class="icon-addcircle"></i
            ></a>
        </div>

        <!--  search modal -->
        <div
            class="modal-backdrop fade show"
            v-if="showModal"
        ></div>
        <div
            class="modal bo-modal fade show"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-add-new-product"
            aria-hidden="true"
            v-if="showModal"
            style="display: block"
        >
            <div
                class="modal-dialog modal-dialog-centered"
                role="document"
                style="max-width: 90%"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">{{ title }}</div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="showModal = false"
                        >
                            <i class="icon-close"></i>
                        </button>
                    </div>

                    <div class="modal-body">
                        <!-- TAB NAV -->
                        <ul
                            class="nav nav-tabs bo-nav"
                            id="tab-add-products"
                            role="tablist"
                        >
                            <!-- NAV - Items -->
                            <li class="nav-item">
                                <a
                                    :class="['nav-link active']"
                                    id="tab-products"
                                    data-toggle="tab"
                                    href="#products"
                                    role="tab"
                                    aria-controls="products"
                                    aria-selected="true"
                                >
                                    <span>{{ subtitle }}</span>
                                    <span class="badge">{{ totalItems }}</span>
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content tab-content-add-products">
                            <div
                                class="tab-pane fade show active"
                                id="all-products"
                                role="tabpanel"
                                aria-labelledby="tab-all-products"
                            >
                                <bo-datatable
                                    ref="assignItemTable"
                                    :select-single-record="selectSingleItem"
                                    :selectable="!selectSingleItem"
                                    :columns="columns"
                                    :get-records-url="getItemsUrl"
                                    :without-product-advance-search="withoutItemAdvanceSearch"
                                    @hook:mounted="initialWatcher"
                                    @done_loading="tableDoneLoadingHandler"
                                    @selected_single_record="tableSelectedSingleItemHandler"
                                    @selected_multiple_records="tableSelectedMultipleItemsHandler"
                                    @per_total_change_return="perTotalChangeReturnHandler(...arguments)"
                                ></bo-datatable>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer d-flex justify-content-between">
                        <div class="selections">
                            <div class="total-selected"></div>
                        </div>
                        <div class="buttons">
                            <button
                                type="button"
                                class="btn btn-rounded light"
                                data-dismiss="modal"
                                @click="cancelButtonHandler"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                class="btn btn-rounded arclight"
                                data-dismiss="modal"
                                :disabled="disableAddButton"
                                @click="addItems"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        v-else
        class="d-flex align-items-center"
    >
        <template v-if="value">
            <template v-for="(item, index) in items">
                <template v-if="index <= meta.length">
                    <template v-if="index == meta.length"
                        ><div
                            class="document is-badge view-more"
                            :key="item.id"
                            @click="showDropdown = !showDropdown"
                        >
                            +{{ items.length - meta.length }}

                            <div
                                v-if="showDropdown && value.length > meta.length"
                                aria-labelledby="dropdownAddItem"
                                class="dropdown-menu dropdown-menu-right"
                                style="display: block"
                                v-click-outside="hidePopup"
                            >
                                <template v-for="(item, index) in items">
                                    <template v-if="index >= meta.length">
                                        <div
                                            class="document is-badge"
                                            :key="item.id"
                                        >
                                            <div
                                                v-if="badgeKeyIsDefined(item)"
                                                class="badge arclight"
                                            >
                                                {{ item[meta.badgeKey] }}
                                            </div>
                                            <span>
                                                {{ item[meta.displayKey] }}
                                            </span>
                                        </div></template
                                    >
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="index < meta.length">
                        <div
                            class="document is-badge"
                            :key="item.id"
                        >
                            <div
                                v-if="badgeKeyIsDefined(item)"
                                class="badge arclight"
                            >
                                {{ item[meta.badgeKey] }}
                            </div>
                            <span>
                                {{ item[meta.displayKey] }}
                            </span>
                        </div></template
                    ></template
                >
            </template>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        subtitle: {
            type: String,
            default: "",
        },
        columns: {
            type: Array,
            default: () => [],
        },
        meta: {
            type: Object,
            default: () => ({}),
        },
        editable: {
            type: Boolean,
            default: true,
        },
        id: {
            type: String,
            default: "",
        },
        getItemsUrl: {
            type: String,
            default: "",
        },
        value: {
            type: Array,
            default: () => [],
        },
        selectSingleItem: {
            type: Boolean,
            default: true,
        },
        ordered: {
            //HACK
            type: Number,
            default: 0,
        },
        invoiceData: {
            //HACK
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            showModal: false,
            withoutItemAdvanceSearch: true,
            showDropdown: false,
            search: "",
            searchResult: [],
            selectedItemsCount: 0,
            selectedItem: "",
            totalItems: 0,
            primaryKey: "",
        };
    },

    computed: {
        disableAddButton() {
            return (
                (this.selectSingleItem && this.selectedItem === "") ||
                (!this.selectSingleItem && this.selectedItemsCount === 0)
            );
        },

        items() {
            return this.value;
        },
    },

    methods: {
        initialWatcher() {
            this.primaryKey = this.$refs.assignItemTable.primaryKey;
        },

        badgeKeyIsDefined(item) {
            return item[this.meta.badgeKey] != null;
        },

        addItems() {
            if (this.selectSingleItem) {
                var selectedItems = this.$refs.assignItemTable.records.filter((record) => {
                    return this.selectedItem == record[this.primaryKey];
                });
            } else {
                var selectedItems = this.$refs.assignItemTable.records.filter((record) => record.checked);
            }
            this.selectedItem = "";
            this.selectedItemsCount = 0;
            this.showDropdown = false;
            this.showModal = false;

            this.$emit("change", this.items.concat(selectedItems));
            this.$emit("add", selectedItems);
        },

        hidePopup() {
            this.showDropdown = 0;
        },

        removeItem(index) {
            const deletedItems = this.items.splice(index, 1);
            this.$emit("change", this.items);
            this.$emit("delete", deletedItems);
        },

        cancelButtonHandler() {
            this.selectedItem = "";
            this.selectedItemsCount = 0;
            this.showModal = false;
        },

        tableDoneLoadingHandler() {
            this.removeSelectedRows();

            this.totalItems = this.$refs.assignItemTable.tableFooter
                ? this.$refs.assignItemTable.tableFooter.total
                : this.$refs.assignItemTable.records.length;
        },

        tableSelectedSingleItemHandler(record) {
            this.selectedItem = record[this.primaryKey];
        },

        tableSelectedMultipleItemsHandler(record) {
            this.selectedItemsCount = record.length;
        },

        removeSelectedRows() {
            const itemKeys = this.items.map((item) => item[this.primaryKey]);
            this.$refs.assignItemTable.records = this.$refs.assignItemTable.records.filter(
                (record) => !itemKeys.includes(record[this.primaryKey])
            );
        },

        perTotalChangeReturnHandler(index, event) {
            //HACK
            let totalReturned = 0;
            for (const record of this.$refs.assignItemTable.records) {
                totalReturned += record.return.returned;
            }

            for (const record of this.$refs.assignItemTable.records) {
                let totalReturnedForOtherInvoices = totalReturned - record.return.returned;

                let totalReturnedForInvoice = 0;
                for (const lineItemId in this.invoiceData.data[record.transfer_id]) {
                    totalReturnedForInvoice += this.invoiceData.data[record.transfer_id][lineItemId].returned;
                }

                const initialReturned =
                    this.invoiceData.stats[record.transfer_id] == null
                        ? 0
                        : this.invoiceData.stats[record.transfer_id].initial;

                totalReturnedForInvoice = record.return.initialReturned - (initialReturned - totalReturnedForInvoice);

                const remainderReturned = Math.min(
                    this.ordered - totalReturnedForOtherInvoices,
                    record.ordered - totalReturnedForInvoice
                );

                const maxPossibleReturned = Math.min(record.return.returned, remainderReturned);

                record.returned = totalReturnedForInvoice;
                record.return.ordered = remainderReturned;
                record.return.returned = maxPossibleReturned;

                totalReturned = totalReturnedForOtherInvoices + maxPossibleReturned;
            }
        },
    },
};
</script>
